export default "__VITE_ASSET__DvTOqB_v__"